import { IQuizItem } from '../../types/quiz';

import { ChartQuestion } from './ChartQuestion';
import { EmailQuestion } from './EmailQuestion';
import { InfoQuestion } from './InfoQuestion';
import { MultipleQuestion } from './MultipleQuestion';
import { SingleQuestion } from './SingleQuestion';

type Props = {
  item: IQuizItem;
  onSubmit: (value?: string | string[]) => void;
};

export const Questions = ({ item, onSubmit }: Props) => {
  const Question = {
    info: InfoQuestion,
    email: EmailQuestion,
    chart: ChartQuestion,
    single: SingleQuestion,
    multiple: MultipleQuestion,
  }[item.type];

  return Question ? <Question item={item} onSubmit={onSubmit} /> : null;
};
